import React, { useState } from 'react'
import { Button, Col, Form } from 'react-bootstrap'
import { Formik } from 'formik'
import * as Yup from 'yup'
import Link from 'next/link'
import { redirect } from '@bigyellow/libs/redirect'
import { withStore } from '@bigyellow/store'
import { login } from '@bigyellow/api/auth'
import { handle_api_exception } from '@bigyellow/api/exception'
import { FORGOT_PASSWORD, HOME } from '@bigyellow/routes'
import { setCurrentCustomer } from '@bigyellow/libs/customer'
import PasswordShowHide from '@bigyellow/components/Forms/PasswordShowHide'
import { MfaAuth } from '@bigyellow/components/MfaCode'
import ErrorMessages from '@bigyellow/components/Shared/ErrorMessages'
import NotAllowedToCheckinMessage from '@bigyellow/components/NotAllowedToCheckinMessage'
import { setItem } from '@bigyellow/libs/storage'

const SignIn = ({ store }) => {
  const [submitting, setSubmitting] = useState(false)
  const [loginUser, setLoginUser] = useState({
    email: '',
    password: '',
    customer_type: '',
    recaptcha: '',
    rememberMe: false,
    sms: false,
    totp: false,
    phoneEnd: '',
    debugCode: ''
  })
  const [errors, setErrors] = useState([])
  const [showMfa, setShowMfa] = useState(false)
  const [shouldNotLogin, setShouldNotLogin] = useState(false)
  const httpClient = store ? store.get('http_client') : null
  const notify = store ? store.get('notify') : null

  const signIn = (values) => {

    setSubmitting(true)
    const { email, password, customer_type, room_contract, rememberMe } = values

    const payload = {
      email,
      password,
      customer_type,
      room_contract,
      ...(rememberMe && { rememberMe: 1 })
    };
    // let newLoginUser = {...loginUser, ...values};
    // alert('newLoginUser '+ JSON.stringify(newLoginUser));

    (async () => {

      try {
        let res = await login(httpClient, payload)

        if (res?.data?.status === 'success') {
          let { sms, totp, phoneEnd } = res.data.data
          let debugCode = res.data?.debug?.code
          let newLoginUser = { ...payload, sms: sms, totp: totp, phoneEnd: phoneEnd, debugCode: debugCode }
          setLoginUser(newLoginUser)
          setShowMfa(true)
        }
      } catch (error) {
        const newErrorMessageList = [handle_api_exception(error)]
        setErrors(newErrorMessageList)
        notify(handle_api_exception(error), { type: 'error' })
      } finally {

        setSubmitting(false)
      }

    })()

  }

  const schema = Yup.object().shape({
    email: Yup.string().required('Email is required'),
    password: Yup.string().required('Password is required')
  })

  if (shouldNotLogin) {
    return <NotAllowedToCheckinMessage />
  }

  if (showMfa) {
    return (
      <MfaAuth
        authCredentials={loginUser}
        store={store}
        reSendVerificationCode={() => {
          // alert('resend code' + JSON.stringify(loginUser))
          signIn(loginUser)
        }}
        onVerifiedSuccess={(data) => {
          if (!data) return

          const { customerAccounts } = data

          if (customerAccounts.length === 0) {
            setShouldNotLogin(true)
            return false
          }

          setCurrentCustomer(data).then(() => {
            store.set('customer_type', 'DOM')
            setItem('customer_is_new', false)
            redirect(HOME)
          })
        }}
        onCancelVerification={() => {
          redirect(HOME)
        }}
      />
    )
  }

  return (
    <div className="form-content">
      <ErrorMessages errorList={errors} />
      <Formik
        enableReinitialize
        validationSchema={schema}
        onSubmit={signIn}
        initialValues={loginUser}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          isValid,
          errors
        }) => (
          <Form noValidate onSubmit={handleSubmit} id="signinForm" method={`post`}>
            <Form.Row>
              <Form.Group as={Col} controlId="validationEmail" className={`material label-top`}>
                <Form.Control
                  type="text"
                  name="email"
                  value={values.email}
                  onChange={(e) => {
                    e.target.value = e.target.value.trim()
                    handleChange(e)
                  }}
                  isInvalid={touched.email && errors.email}
                />
                <Form.Label>Email</Form.Label>
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </Form.Group>
            </Form.Row>

            <Form.Row>
              <Form.Group as={Col} controlId="validationPassword" className={`material label-top`}>
                <PasswordShowHide
                  name="password"
                  value={values.password}
                  label={'Password'}
                  onChange={handleChange}
                  isInvalid={touched.password && errors.password}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.password}
                </Form.Control.Feedback>
              </Form.Group>
            </Form.Row>

            <Form.Row>
              <Col className="mt-3" xs="12">
                <Link href={`${FORGOT_PASSWORD}/`}>
                  <a className="fp-link">Forgot Password?</a>
                </Link>
              </Col>
              <Col className="mt-4" xs="12">
                <Form.Group controlId="formRememberMe">
                  <Form.Check
                    type="checkbox"
                    label="Remember me for 14 days"
                    name={'rememberMe'}
                    checked={values.rememberMe}
                    onChange={handleChange}
                    custom
                  />
                  {values.rememberMe && (
                    <Form.Label className={`text-xs muted rm-message ml-4 pl-2`}>
                      Only use this if on a private computer.
                    </Form.Label>
                  )}
                </Form.Group>
              </Col>
            </Form.Row>

            <Form.Row className="justify-content-center my-4">
              <Button type="submit" disabled={submitting}>
                Sign In
              </Button>
            </Form.Row>

            <div id="recaptcha" />
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default withStore(SignIn)